import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { useGetPersonalDataControllersGridViewFromCache } from "../../../api/personalDataControllers";
import { DynamicGrid } from "../../../dynamicGrid";
import { usePrivacyNavigate } from "../../../shared/usePrivacyNavigate";
import { PageTitle } from "../../../shared/Page";
import { CreatePersonalDataControllerDialog } from "./CreatePersonalDataControllerDialog";

export const PersonalDataControllersGridToolbar: FC = () => {
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();
  const personalDataControllersGridView = useGetPersonalDataControllersGridViewFromCache();

  const existingPdcTenantIds = personalDataControllersGridView.personalDataControllers.map(pdc => pdc.tenantId);

  return (
    <DynamicGrid.Toolbar
      pageTitle={
        <PageTitle
          title={t("PersonalDataControllersGrid.Header")}
          subTitle={t("PersonalDataControllersGrid.SubTitle")}
        />
      }
      actionButtons={
        <DynamicGrid.CreateNewButton
          labelKey="CreatePersonalDataController.Button"
          renderDialog={({ onClose }) => (
            <CreatePersonalDataControllerDialog
              onClose={onClose}
              existingPdcTenantIds={existingPdcTenantIds}
              onCreated={id => navigate(paths.pdcInline(id))}
            />
          )}
        />
      }
    />
  );
};
